module.exports = __webpack_public_path__ + "static/img/car_integral.08c2335.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/car_integral.png
// module id = znP8
// module chunks = 1